/**
 * Created by tuannguyenla on 5/19/2016.
 */

import { Injectable } from '@angular/core';

@Injectable()
export class CentreUrl {
    public static get CREATE_GROUP_CONSULTATION(): string { return '/api/centre/CreateGroupConsultation'; }
    public static get GET_CENTRE(): string { return '/api/centre'; }
    public static get GET_COUNTRIES_HAS_CENTRE(): string { return '/api/centre/countries'; }
    public static get GET_CENTRE_GROUPS(): string { return '/api/centre/groups'; }
    public static get GET_WAITING_ROOM(): string { return '/api/centre/waitingroom'; }
    public static get GET_PREVIOUS_WAITING_ROOM(): string { return '/api/centre/previousWaitingRoom'; }
    public static get REMOVE_PATIENT_FROM_WAITING_ROOM(): string { return '/api/centre/removePatientFromWaitingRoom/{consultationId}'; }
    public static get ADD_PATIENT_TO_WAITING_ROOM(): string { return '/api/centre/{patientId}/AddPatientToWaitingRoom'; }
    public static get NEW_CONSULTATION(): string { return '/api/centre/{0}/NewConsultation/{1}'; }
    public static get GET_CLINIC_TYPE(): string { return '/api/centre/clinicType'; }
    public static get SEARCH_PATIENT(): string { return '/api/centre/SearchPatient'; }
    public static get SEARCH_SIMILAR_PATIENT(): string { return '/api/centre/SearchSimilarPatient'; }
    public static get GET_BASE_CENTRE(): string { return '/api/centre/baseCentre'; }
    public static get GET_CENTRE_BY_CURRENCY(): string { return '/api/centre/getcentresbycurrency/'; }  
    public static get ADD_NEW_VACCINE_BATCH(): string { return '/api/batch/vaccinebatch'; }  
    public static get UPDATE_VACCINE_BATCH(): string { return '/api/batch/vaccinebatch/'; }  
    public static get GET_VACCINE_BATCH_BY_ID(): string { return '/api/batch/vaccinebatch/{id}/detail'; }  
    public static get REMOVE_VACCINE_BATCH(): string { return '/api/batch/delete/'; }  
    public static get GET_ALL_REASON(): string { return '/api/batch/getreasons'; }  
    public static get GET_ALL_VACCINE(): string { return '/api/batch/getvaccines'; }  
    public static get GET_ALL_TIME_ZONE(): string { return '/api/centre/gettimezone'; }      
    public static get GET_CENTRE_LOGO(): string { return '/api/Centre/{0}/Logo';}
}



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/shared/urls/centre.url.ts